import { render, staticRenderFns } from "./BulkConversionCreateTable.vue?vue&type=template&id=fc433d1c&scoped=true"
import script from "./BulkConversionCreateTable.vue?vue&type=script&lang=ts"
export * from "./BulkConversionCreateTable.vue?vue&type=script&lang=ts"
import style0 from "./BulkConversionCreateTable.vue?vue&type=style&index=0&id=fc433d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc433d1c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/conversion/bulk-conversion-edit-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fconversion%2FBulkConversionCreateTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports